export default __webpack_public_path__ + "static/media/avataaars.aa9aff02.svg";